import { useState } from 'react';
import { api } from '../api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    setError(null);
    try {
      await api.requestMagicLink(email.trim().toLowerCase());
      setSubmitted(true);
    } catch (err: any) {
      setError(err?.message || 'Could not send magic link.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm bg-paper border border-rule p-10 shadow-sm">
        <div className="font-display text-2xl font-medium text-ink mb-2">
          Cadence Advisers <span className="italic text-ink-light font-normal">· admin</span>
        </div>
        <div className="font-mono text-[11px] uppercase tracking-widest text-ink-light mb-8">Tempo v2</div>

        {!submitted ? (
          <form onSubmit={handleSubmit}>
            <label className="block">
              <span className="block font-mono text-[11px] uppercase tracking-wider text-ink-light mb-2">
                Email
              </span>
              <input
                type="email"
                autoComplete="email"
                inputMode="email"
                required
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@cadenceadvisers.com"
                className="w-full px-3 py-2 border border-rule bg-cream font-serif text-base text-ink focus:outline-none focus:border-accent"
              />
            </label>

            {error && (
              <div className="mt-4 text-sm text-accent bg-cream border border-rule p-3 font-serif">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={submitting || !email.trim()}
              className="mt-6 w-full px-4 py-2 bg-ink text-paper font-serif text-sm tracking-wide hover:bg-accent disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              {submitting ? 'Sending…' : 'Send magic link →'}
            </button>
          </form>
        ) : (
          <div className="font-serif text-sm text-ink leading-relaxed">
            <p className="mb-4">If <span className="font-medium">{email}</span> is registered as an admin, a sign-in link is on its way.</p>
            <p className="text-ink-light">The link expires in 15 minutes and can only be used once.</p>
            <button
              type="button"
              onClick={() => { setSubmitted(false); setEmail(''); }}
              className="mt-6 font-mono text-[11px] uppercase tracking-wider text-ink-light hover:text-accent"
            >
              ← Try a different email
            </button>
          </div>
        )}

        <div className="mt-10 pt-6 border-t border-rule font-mono text-[10px] uppercase tracking-widest text-ink-light text-center">
          Trouble? <a href="mailto:peter@cadenceadvisers.com" className="text-accent hover:underline">peter@cadenceadvisers.com</a>
        </div>
      </div>
    </div>
  );
}
